"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEntity = exports.Entity = void 0;
var events_1 = require("./events");
var type_1 = require("./type");
var initilization_context_1 = require("./initilization-context");
var object_meta_1 = require("./object-meta");
var property_1 = require("./property");
var helpers_1 = require("./helpers");
var entity_serializer_1 = require("./entity-serializer");
var Entity = /** @class */ (function () {
    function Entity(type, id, properties, context) {
        var _this = this;
        if (arguments.length === 0) {
            // TODO: Warn about direct call in dev build?
        }
        else if (Entity.ctorDepth === 0)
            throw new Error("Entity constructor should not be called directly.");
        else {
            Object.defineProperty(this, "_context", { enumerable: false, configurable: false, writable: true, value: null });
            Object.defineProperty(this, "accessed", { enumerable: false, configurable: false, writable: false, value: new events_1.Event() });
            Object.defineProperty(this, "changed", { enumerable: false, configurable: false, writable: false, value: new events_1.Event() });
            var isNew_1 = false;
            if (typeof id === "string")
                type.assertValidId(id);
            else {
                // Was id provided as undefined, or not provided at all?
                if (id !== null && typeof id === "object")
                    properties = id;
                id = type.newId();
                isNew_1 = context ? context.isNewDocument : true;
            }
            // If context was provided, it should be the last argument
            context = arguments[arguments.length - 1];
            if (!(context instanceof initilization_context_1.InitializationContext))
                context = new initilization_context_1.InitializationContext(isNew_1);
            Object.defineProperty(this, "meta", { enumerable: true, configurable: false, writable: false, value: new object_meta_1.ObjectMeta(type, this, id, isNew_1) });
            Object.defineProperty(this, "__fields__", { enumerable: false, configurable: false, writable: false, value: {} });
            Object.defineProperty(this, "__pendingInit__", { enumerable: false, configurable: false, writable: false, value: {} });
            // Register the newly constructed instance
            type.register(this);
            // Initialize existing entity with provided property values
            if (!isNew_1 && properties) {
                // We need to pause processing of callbacks to prevent publishing entity events while still processing the state graph
                context.execute(function () { return _this.init(properties, context); });
            }
            // Raise the initNew or initExisting event on this type and all base types
            this.initialized = new Promise(function (resolve) {
                context.whenReady(function () {
                    // Set values of new entity for provided properties
                    if (isNew_1 && properties)
                        _this.updateWithContext(context, properties);
                    for (var t = type; t; t = t.baseType) {
                        if (isNew_1)
                            t.initNew.publish(t, { entity: _this });
                        else
                            t.initExisting.publish(t, { entity: _this });
                    }
                    context.whenReady(resolve);
                });
            });
        }
    }
    Entity.getSortedPropertyData = function (properties) {
        return helpers_1.entries(properties).sort(function (a, b) {
            return Number(b[1] instanceof Entity) - Number(a[1] instanceof Entity);
        });
    };
    Entity.prototype.init = function (property, context, value) {
        var _a;
        var _this = this;
        if (Entity.ctorDepth === 0) {
            throw new Error("Entity.init() should not be called directly.");
        }
        var properties;
        // Convert property/value pair to a property dictionary
        if (typeof property === "string")
            properties = (_a = {}, _a[property] = value, _a);
        else
            properties = property;
        var initializedProps = new Set();
        var _loop_1 = function (propName, state) {
            var prop = this_1.serializer.resolveProperty(this_1, propName);
            if (prop) {
                if (!prop.isCalculated && !prop.isConstant) {
                    initializedProps.add(prop);
                    var valueResolution = context.tryResolveValue(this_1, prop, state);
                    if (valueResolution)
                        valueResolution.then(function (asyncState) { return _this.initProp(prop, asyncState, context); });
                    else
                        this_1.initProp(prop, state, context);
                }
            }
            // Add $ properties to entity
            else if (propName.startsWith("$")) {
                this_1[propName] = state;
            }
        };
        var this_1 = this;
        // Initialize the specified properties
        for (var _i = 0, _b = Entity.getSortedPropertyData(properties); _i < _b.length; _i++) {
            var _c = _b[_i], propName = _c[0], state = _c[1];
            _loop_1(propName, state);
        }
        // Pass all unspecified properties through the deserializer to allow initialization logic via converters
        for (var _d = 0, _e = this.meta.type.properties.filter(function (p) { return !initializedProps.has(p); }); _d < _e.length; _d++) {
            var prop = _e[_d];
            var value_1 = this.serializer.deserialize(this, undefined, prop, context);
            if (value_1 !== undefined)
                property_1.Property$init(prop, this, value_1);
        }
    };
    Entity.prototype.initProp = function (prop, state, context) {
        var value;
        value = this.serializer.deserialize(this, state, prop, context);
        if (value !== undefined)
            property_1.Property$init(prop, this, value);
    };
    Entity.prototype.updateWithContext = function (context, state) {
        var _this = this;
        var hadContext = !!this._context;
        // Do not allow reentrant updates of the same entity for a given context
        if (this._context === context)
            return;
        // Don't overwrite existing context
        if (!this._context)
            this._context = context;
        // Ensure provided context waits on the existing context to be ready
        else if (this._context !== context)
            context.wait(this._context.ready);
        this.update(state);
        if (context !== null && !hadContext) {
            context.whenReady(function () {
                _this._context = null;
            });
        }
    };
    Entity.createOrUpdate = function (type, state, context) {
        var id = type_1.getIdFromState(type, state);
        var isNew = !id;
        if (!context)
            context = new initilization_context_1.InitializationContext(isNew);
        // We need to pause processing of callbacks to prevent publishing entity events while still processing
        // the state graph
        var instance = context.execute(function () {
            var instance = id && type.get(id);
            if (instance) {
                // Assign state to the existing object
                instance.updateWithContext(context, state);
            }
            else {
                // Cast the jstype to any so we can call the internal constructor signature that takes a context
                // We don't want to put the context on the public constructor interface
                var Ctor = type.jstype;
                // Construct an instance using the known id if it is present
                instance = (id ? new Ctor(id, state, context) : new Ctor(state, context));
            }
            return instance;
        });
        return instance;
    };
    Entity.prototype.update = function (property, value) {
        var _a;
        var _this = this;
        var properties;
        // Convert property/value pair to a property dictionary
        if (typeof property === "string")
            properties = (_a = {}, _a[property] = value, _a);
        else
            properties = property;
        if (!this._context) {
            var wasNew_1 = this.meta.isNew;
            var context_1 = new initilization_context_1.InitializationContext(true);
            context_1.execute(function () { return _this.updateWithContext(context_1, properties); });
            var markPersistedWhenIdAssigned = function () {
                if (wasNew_1 && !_this.meta.isNew)
                    _this.markPersisted();
            };
            // call markPersistedWhenIdAssigned using whenReady and after the promise resolves to ensure models with no async
            // behavior produce the correct outcome upon returning from update()
            context_1.whenReady(markPersistedWhenIdAssigned);
            return context_1.ready.then(markPersistedWhenIdAssigned);
        }
        var context = this._context;
        var _loop_2 = function (propName, state) {
            var prop = this_2.serializer.resolveProperty(this_2, propName);
            if (prop) {
                if (!prop.isCalculated && !prop.isConstant) {
                    var valueResolution = context.tryResolveValue(this_2, prop, state);
                    if (valueResolution)
                        valueResolution.then(function (asyncState) { return _this.setProp(prop, asyncState); });
                    else
                        this_2.setProp(prop, state);
                }
            }
            // Add $ properties to entity
            else if (propName.startsWith("$")) {
                this_2[propName] = state;
            }
        };
        var this_2 = this;
        // Set the specified properties
        for (var _i = 0, _b = Entity.getSortedPropertyData(properties); _i < _b.length; _i++) {
            var _c = _b[_i], propName = _c[0], state = _c[1];
            _loop_2(propName, state);
        }
        return context.ready;
    };
    Entity.prototype.setProp = function (prop, state) {
        var _this = this;
        var value;
        var currentValue = prop.value(this);
        if (type_1.isEntityType(prop.propertyType)) {
            var ChildEntity_1 = prop.propertyType;
            if (prop.isList && Array.isArray(state) && Array.isArray(currentValue)) {
                if (!state.length)
                    currentValue.splice(0);
                else {
                    state.forEach(function (s, idx) {
                        if (!(s instanceof ChildEntity_1))
                            s = _this.serializer.deserialize(_this, s, prop, _this._context, false);
                        // Undefined(IgnoreProperty) got assigned, so do not set the property
                        if (s === undefined)
                            return;
                        // Modifying/replacing existing list item
                        if (idx < currentValue.length) {
                            // If the item is a state object, create/update the entity using the state
                            if (!(s instanceof ChildEntity_1) && typeof s === "object") {
                                var listItem = currentValue[idx];
                                // If the entity is a non-pooled type, update in place
                                // If the entity id matches the id in the state, update in place
                                if (!ChildEntity_1.meta.identifier || type_1.getIdFromState(ChildEntity_1.meta, s) === listItem.meta.id)
                                    listItem.updateWithContext(_this._context, s);
                                else
                                    currentValue.splice(idx, 1, Entity.createOrUpdate(ChildEntity_1.meta, s, _this._context));
                            }
                            else if (s instanceof ChildEntity_1)
                                currentValue.splice(idx, 1, s);
                            else
                                console.warn("Provided state,", s, ", is not valid for type " + ChildEntity_1.meta.fullName + "[].");
                        }
                        // Add a list item
                        else if (s instanceof ChildEntity_1)
                            currentValue.push(s);
                        else
                            currentValue.push(Entity.createOrUpdate(ChildEntity_1.meta, s, _this._context));
                    });
                    // Remove excess items from the list
                    currentValue.splice(state.length);
                }
                // Mark property pendingInit = false, since value is not assigned so the setter is not called
                property_1.Property$pendingInit(this, prop, false);
            }
            else if (state instanceof ChildEntity_1)
                value = state;
            else if (state == null)
                value = null;
            else {
                // Attempt to deserialize the state
                var newState = this.serializer.deserialize(this, state, prop, this._context, false);
                // Undefined(IgnoreProperty) got assigned, so do not set the property
                if (newState === undefined)
                    return;
                if (typeof newState !== "undefined")
                    state = newState;
                // Got null, so assign null to the property
                if (state == null)
                    value = null;
                // Got a valid instance, so use it
                else if (state instanceof ChildEntity_1)
                    value = state;
                // Got something other than an object, so just use it and expect to get a down-stream error
                else if (typeof state !== "object")
                    value = state;
                else if (currentValue && !type_1.getIdFromState(ChildEntity_1.meta, state))
                    currentValue.updateWithContext(this._context, state);
                // Got an object, so attempt to fetch or create and assign the state
                else
                    value = Entity.createOrUpdate(ChildEntity_1.meta, state, this._context);
            }
        }
        else if (prop.isList && Array.isArray(state) && Array.isArray(currentValue)) {
            currentValue.splice.apply(currentValue, __spreadArrays([0, currentValue.length], state.map(function (s) { return _this.serializer.deserialize(_this, s, prop, _this._context); })));
            // Mark property pendingInit = false, since value is not assigned so the setter is not called
            property_1.Property$pendingInit(this, prop, false);
        }
        else
            value = this.serializer.deserialize(this, state, prop, this._context);
        if (value !== undefined)
            try {
                property_1.Property$setter(prop, this, value);
            }
            catch (e) {
                console.warn(e);
            }
    };
    Entity.prototype.get = function (property) {
        return this.meta.type.getProperty(property).value(this);
    };
    Entity.prototype.toString = function (format, formatEval) {
        // Get the entity format to use
        var formatter = null;
        if (format) {
            formatter = this.meta.type.model.getFormat(this.constructor, format, formatEval);
        }
        else {
            formatter = this.meta.type.format;
        }
        // Use the formatter, if available, to create the string representation
        if (formatter) {
            return formatter.convert(this);
        }
        else {
            return this.meta.type.fullName + "|" + this.meta.id;
        }
    };
    Object.defineProperty(Entity.prototype, "serializer", {
        get: function () {
            return this.meta.type.model.serializer;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Produces a JSON-valid object representation of the entity.
     * @param entity
     */
    Entity.prototype.serialize = function (settings) {
        if (settings === void 0) { settings = entity_serializer_1.DefaultSerializationSettings; }
        return this.serializer.serialize(this, settings);
    };
    Entity.prototype.markPersisted = function () {
        if (!this.meta.type.identifier || !this.meta.type.identifier.value(this))
            return;
        var visited = new Set();
        var _persist = function (entity) {
            if (visited.has(entity))
                return;
            visited.add(entity);
            entity.meta.isNew = false;
            // visit reference properties with non-identifying types
            for (var _i = 0, _a = entity.meta.type.properties.filter(function (p) { return type_1.isEntityType(p.propertyType) && !p.propertyType.meta.identifier; }); _i < _a.length; _i++) {
                var property = _a[_i];
                var value = property.value(entity);
                if (Array.isArray(value))
                    value.forEach(function (item) { return _persist(item); });
                else if (value)
                    _persist(value);
            }
        };
        _persist(this);
    };
    Entity.ctorDepth = 0;
    return Entity;
}());
exports.Entity = Entity;
function isEntity(obj) {
    return obj && obj.meta && obj.meta.type && obj.meta.type.jstype && type_1.isEntityType(obj.meta.type.jstype);
}
exports.isEntity = isEntity;
